import React from 'react';
import FilePDF from '../resources/svg/FilePDF';
import FileMP3 from '../resources/svg/FileMP3';
import FileAVI from '../resources/svg/FileAVI';
import FileTXT from '../resources/svg/FileTXT';
import FileZIP from '../resources/svg/FileZIP';
import FileTAR from '../resources/svg/FileTAR';
import FileCSV from '../resources/svg/FileCSV';
import FileHTML from '../resources/svg/FileHTML';
import FileJSON from '../resources/svg/FileJSON';
import FileCSS from '../resources/svg/FileCSS';
import FileXML from '../resources/svg/FileXML';
import FilePNG from '../resources/svg/FilePNG';
import FileXLS from '../resources/svg/FileXLS';
import FileDOC from '../resources/svg/FileDOC';
import FilePPT from '../resources/svg/FilePPT';
import File from '../resources/svg/File';
import mimeMatch from 'mime-match';
import i18n from 'i18next';

class MediasService {

    TEXT = 'text';
    HTML = 'html';
    CSS = 'css';
    CSV = 'csv';
    PDF = 'pdf';
    JSON = 'json';
    XML = 'xml';
    ZIP = 'zip';
    TAR = 'tar';
    AUDIO = 'audio';
    IMAGES = 'images';
    VIDEOS = 'videos';
    EXCEL = 'excel';
    WORD = 'word';
    POWERPOINT = 'powerpoint';

    SUPPORTED_MIME_TYPES = {
        'text/plain': this.TEXT,
        'text/richtext': this.TEXT,
        'text/html': this.HTML,
        'text/css': this.CSS,
        'text/csv': this.CSV,
        'application/pdf': this.PDF,
        'application/json': this.JSON,
        'application/xml': this.XML,
        'application/zip': this.ZIP,
        'application/x-bzip': this.ZIP,
        'application/x-bzip2': this.ZIP,
        'application/x-7z-compressed': this.ZIP,
        'application/gzip': this.ZIP,
        'application/x-gzip': this.ZIP,
        'application/x-tar': this.TAR,
        'application/vnd.ms-excel': this.EXCEL,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': this.EXCEL,
        'application/vnd.ms-powerpoint': this.POWERPOINT,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': this.POWERPOINT,
        'application/msword': this.WORD,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': this.WORD,
        'audio/*': this.AUDIO,
        'image/*': this.IMAGES,
        'video/*': this.VIDEOS,
    };

    SUPPORTED_EXTENSION = {
        'txt': this.TEXT,
        'md': this.TEXT,
        'html': this.HTML,
        'css': this.CSS,
        'pdf': this.PDF,
        'json': this.JSON,
        'xml': this.XML,
        'zip': this.ZIP,
        'rar': this.ZIP,
        'gz': this.ZIP,
        'tar': this.TAR,
        'xls': this.EXCEL,
        'xlsx': this.EXCEL,
        'ods': this.EXCEL,
        'doc': this.WORD,
        'docx': this.WORD,
        'odt': this.WORD,
        'ppt': this.POWERPOINT,
        'pptx': this.POWERPOINT,
        'odp': this.POWERPOINT,
        'gp': this.AUDIO,
        'aac': this.AUDIO,
        'flac': this.AUDIO,
        'm4a': this.AUDIO,
        'm4b': this.AUDIO,
        'm4p': this.AUDIO,
        'mmf': this.AUDIO,
        'mp3': this.AUDIO,
        'mpc': this.AUDIO,
        'mpg': this.AUDIO,
        'ogg': this.AUDIO,
        'oga': this.AUDIO,
        'mogg': this.AUDIO,
        'raw': this.AUDIO,
        'rf64': this.AUDIO,
        'tta': this.AUDIO,
        'vox': this.AUDIO,
        'wav': this.AUDIO,
        'wma': this.AUDIO,
        'wv': this.AUDIO,
        'cda': this.AUDIO,
        'webm': this.VIDEOS,
        'mkv': this.VIDEOS,
        'flv': this.VIDEOS,
        'vob': this.VIDEOS,
        'ogv': this.VIDEOS,
        'avi': this.VIDEOS,
        'mov': this.VIDEOS,
        'wmv': this.VIDEOS,
        'yuv': this.VIDEOS,
        'amv': this.VIDEOS,
        'mp4': this.VIDEOS,
        'mpeg': this.VIDEOS,
        'm4v': this.VIDEOS,
        '3gp': this.VIDEOS,
        '3g2': this.VIDEOS,
        'f4v': this.VIDEOS,
        'f4p': this.VIDEOS,
        'f4a': this.VIDEOS,
        'f4b': this.VIDEOS,
        'jpg': this.IMAGES,
        'jpeg': this.IMAGES,
        'jp2': this.IMAGES,
        'png': this.IMAGES,
        'gif': this.IMAGES,
        'webp': this.IMAGES,
        'bmp': this.IMAGES,
        'tiff':this.IMAGES,
        'tif':this.IMAGES,
        'svg':this.IMAGES,
        'psd':this.IMAGES,
        'heif':this.IMAGES,
        'heic':this.IMAGES,
    };

    shortNameForMime(mime) {
        for (let supported in this.SUPPORTED_MIME_TYPES) {
            if (mimeMatch(mime, supported)) {
                return this.SUPPORTED_MIME_TYPES[supported];
            }
        }
        return null;
    }

    shortNameForExt(ext) {
        for (let supported in this.SUPPORTED_EXTENSION) {
            if (ext === supported) {
                return this.SUPPORTED_EXTENSION[supported];
            }
        }
        return null;
    }

    mimeTypesForShortName(short) {
        let mimes = [];

        for (let mime in this.SUPPORTED_MIME_TYPES) {
            let shortName = this.SUPPORTED_MIME_TYPES[mime];

            if (shortName === short) {
                mimes.push(mime);
            }
        }

        return mimes;
    }

    sortedMediasForShortMime(medias, shortMime) {
        let mimeMedias = [];

        if (medias && shortMime) {
            medias.forEach(media => {
                let short = null;
                if(media.mime_type) {
                    short = this.shortNameForMime(media.mime_type);
                }
                if (short === null && media.name !== undefined && media.name !== null) {
                    const nameSplit = media.name.split('.');
                    const ext = nameSplit[nameSplit.length - 1];
                    short = this.shortNameForExt(ext);
                }
                if (short === shortMime) {
                    mimeMedias.push(media);
                }
            });
        }

        return mimeMedias.sort((lhs, rhs) => {
            return lhs.order - rhs.order;
        });
    }

    sortMediasByShortMimeType(medias) {
        let mediasByType = {};

        medias.forEach(media => {
            if (media.mime_type) {
                let short = this.shortNameForMime(media.mime_type);
                if (short === null) {
                    const nameSplit = media.name.split('.');
                    const ext = nameSplit[nameSplit.length - 1];
                    short = this.shortNameForExt(ext);
                }
                if (mediasByType[short] === undefined) {
                    mediasByType[short] = [];
                }
                mediasByType[short].push(media);
            }
        });

        return mediasByType;
    }

    supportedMimeTypes() {
        return Object.keys(this.SUPPORTED_MIME_TYPES);
    }

    iconForMedia(media) {
        if (media) {
            return this.imageForShortMime(
                this.shortNameForMime(media.mime_type),
            );
        }

        return null;
    }

    isImage(media) {
        if (media) {
            return this.shortNameForMime(media.mime_type) === this.IMAGES;
        }

        return false;
    }

    displayNameForShortMime(shortMime) {
        switch (shortMime) {
            case this.TEXT:
            case this.HTML:
            case this.CSS:
            case this.CSV:
            case this.PDF:
            case this.JSON:
            case this.XML:
            case this.ZIP:
            case this.TAR:
            case this.AUDIO:
            case this.IMAGES:
            case this.VIDEOS:
            case this.EXCEL:
            case this.POWERPOINT:
            case this.WORD:
                return i18n.t('medias.mime.' + shortMime);

            default:
                return i18n.t('medias.mime.other');
        }
    }

    imageForShortMime(shortMime, color) {
        switch (shortMime) {
            case this.TEXT:
                return <FileTXT color={color} />;
            case this.HTML:
                return <FileHTML color={color} />;
            case this.CSS:
                return <FileCSS color={color} />;
            case this.CSV:
                return <FileCSV color={color} />;
            case this.PDF:
                return <FilePDF color={color} />;
            case this.JSON:
                return <FileJSON color={color} />;
            case this.XML:
                return <FileXML color={color} />;
            case this.ZIP:
                return <FileZIP color={color} />;
            case this.TAR:
                return <FileTAR color={color} />;
            case this.AUDIO:
                return <FileMP3 color={color} />;
            case this.IMAGES:
                return <FilePNG color={color} />;
            case this.VIDEOS:
                return <FileAVI color={color} />;
            case this.EXCEL:
                return <FileXLS color={color} />;
            case this.POWERPOINT:
                return <FilePPT color={color} />;
            case this.WORD:
                return <FileDOC color={color} />;
            default:
                return <File color={color} />;
        }
    }
}

export default new MediasService();



// WEBPACK FOOTER //
// src/services/medias.js